module.exports = __webpack_public_path__ + "img/07-27-160.49760d6d.jpg";